import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BusinessUnitRole } from '@dal/core';

@Component({
  selector: 'dal-shared-ui-business-unit-selector',
  templateUrl: './business-unit-selector.component.html',
  styleUrl: './business-unit-selector.component.scss',
})

export class BusinessUnitSelectorComponent {
   constructor(
    public dialogRef: MatDialogRef<BusinessUnitSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      businessUnits: BusinessUnitRole[];
      name: string;
      dialogHeading: string;
    }
  ) {}

  businessUnits = this.data.businessUnits;
  username: string = this.data.name;
  heading: string = this.data.dialogHeading;
  selectedUnit: number | null = this.businessUnits[0]?.business_unit_id ?? null;

  onProceed() {
    if (this.selectedUnit == null) {
      console.warn('No business unit selected; dialog will remain open.');
      return;
    }

    this.dialogRef.close(this.selectedUnit);
    console.log('Selected Business Unit:', this.selectedUnit);
    // You can emit or store this selection as needed
  }
}
